<template>  
  <v-card>
    <v-toolbar flat>      
      <v-text-field flat dense filled
        v-model="term"
        append-icon="search"
        label="Search Calon"
        single-line
        hide-details        
        @input="search"
        style="max-width:200px"
      ></v-text-field>                 
      <v-spacer/>
      <v-btn fab color="green" dark small absolute right :to="{name:'master/calon/form'}"><v-icon>add</v-icon></v-btn>                      
    </v-toolbar>
    <v-card-text class="pa-0">      
      <v-container fluid grid-list-lg class="ma-0 pa-0">
        <v-layout row>
          <v-flex xs12 md12 style="position:relative">            
            <v-data-table dense 
              :headers="headers"
              :items="items"              
              :loading="loading"
              loading-text="Loading... Please wait"
              :items-per-page="-1"
              hide-default-footer  
              :options.sync="pagination" 
              must-sort                       
            > 
              <template v-slot:item.image="{ item }">
                <v-avatar size="40" :color="item.color">
                  <img v-if="item.tinyFileBase64" :src="item.tinyFileBase64" :alt="item.akronim"/>
                </v-avatar>                
              </template>                            
              <template v-slot:item.action="{ item }">
                <v-btn icon small color="blue" :to="{name:'master/calon/form',query:{id:item.id}}"><v-icon>edit</v-icon></v-btn>
              </template>              
            </v-data-table>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="totalPages"
                circle
                :total-visible="9"
              ></v-pagination>
            </div>
          </v-flex>          
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card> 
</template>

<script>
import { debounce } from 'lodash'
import Model from '@/app/models/master/Calon'
const  model = new Model()

export default {
  data () {
    return {
      term : null,
      headers:[        
        {text:'No', value:'no'},
        {text:'Foto', value:'image'},
        {text:'Name', value:'name'},        
        {text:'Akronim', value:'akronim'},
        {text:'Kompetisi', value:'kompetisi.name'},
        {text:'Partai', value:'partai.akronim'},
        {text:'Tagline', value:'tagline'},        
        {text:'#', value:'action'}
      ],
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,
      status: {1:'active',0:'inactive'},
    }
  },
  computed:{
    
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  },  
  created () {
    this.readItems()
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'no';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,
        sort:sortby,
        expand:'tinyFileBase64,partai,kompetisi'
      }

      model.all(params)
        .then(response => {
          this.items = response.data;
          this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })
    },    
  },  
}
</script>